import { Fragment } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import UserActivityStream from './UserActivityStream';

const UserActivityStreamPage = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='User Activity Stream' title='User Activity Stream' />
      <div className='card-datatable app-user-list'>
        <UserActivityStream />
      </div>
    </Fragment>
  );
};

export default UserActivityStreamPage;
